import React from 'react';
import './Welcome.css';

const Welcome = () => {
  return (
    <div className="welcome-page">
      <div className="welcome-header">
        <div className="welcome-title">
          <h1>Welcome Admin</h1>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
